<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-textarea v-model="text" rows="10" class="bg-white" />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <h6 class="mb-2">Quantidade</h6>
        <vs-input v-model="options.quantity" />
      </div>
    </div>
    <br>
    <div class="flex flex-wrap items-center" slot="footer">
      <vs-button class="mr-6 bg-success" @click="add()">Adicionar</vs-button>
      <vs-button class="mr-6" @click="generate()">Gerar</vs-button>
      <AssignImageToPdf ref="assignImageToPdf"></AssignImageToPdf>
    </div>
  </div>
</template>

<script>
import helpers from '@/helpers'
import AssignImageToPdf from "./AssignImageToPdf.vue"

export default {
  data() {
    return {
      qrCodes: [],
      options: { watermark: true, quantity: 5 },
      text: '',
    }
  },
  components: {
    AssignImageToPdf
  },
  methods: {
    setDefaultText() {
      this.text = `N° Ordem de Produção: 15
Data: ${helpers.dateHelper.getDatePTBR()}
Técnico: Diego
Modelo: KM2810 FS1135 M2035
Quantidade: 5
Recondicionada`
    },
    add() {
      this.qrCodes.push({ text: this.text, options: this.options })
    },
    async generate() {
      try {
        this.$vs.loading();
        await this.$refs.assignImageToPdf.generate(this.qrCodes.length ? this.qrCodes : [{ text: this.text, options: this.options }])
      } catch (error) {
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel gerar: " + error.response.data,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      } finally {
        this.$vs.loading.close();
      }
    }
  },
  created() {
    this.setDefaultText()
  }
}

</script>

<style>

</style>
